import DepartmentIcon from './component'

export default DepartmentIcon
